import React, { Component, Fragment } from 'react';
import 'react-datetime/css/react-datetime.css';
import { Link, Switch, Route, withRouter, Redirect } from 'react-router-dom';

import ActionButtonContainer from '../../../components/views/ActionButtonContainer';
import ViewsTable from '../../../components/tables/ViewsTable';
import LoadingWizard from '../../../components/spinner/wizard';
import EditFeedItem from './modals/editFeedItem';
import DeleteGalleryModal from './modals/deleteGallery';
import SelectField from '../../../components/inputs/selectField';
import InputField from '../../../components/inputs/inputField';
import AddTeamModal from './modals/addTeamModal';
import API from '../../../utils/API';
import SectionHeader from '../../../components/views/SectionHeader';
import TabsContainer from '../../../components/views/TabsContainer';
import SectionFooter from '../../../components/views/SectionFooter';

import FilesUploaderModal from "../../../components/files/filesUploaderModal";


import { at, reduce } from 'lodash';

class EngagementTeams extends Component {
    constructor(props) {
        super(props);

        const columns = {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email'
        };
        const columnTypes = {
            firstName: 'string',
            lastName: 'string',
            email: 'string'
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });


        this.state = {
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            checkedItems: {},
            feedItems: [],
            isGridLayout: true,
            loading: true,
            toggleEditFile: false,
            markedItem: null,
            toggleAddTeam: false,
            searchTerm: '',
            engagementTeams: [],
            sidePanelOpen: false,
            tabs: 0,
            selectedSection: 0,
            editing: false,
            editedTeam: {},
            uploadingTeamIcon: false,
            searchText: '',
            selectedColumnSort: null,
            sortDesc: false

        };
    }

    componentDidMount() {

        this.setState({
            editedTeam: { ...this.props.team },
            loading: false,
        });
    }




    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false
        });
    };

    toggleLayout = (selected) => {
        this.setState({ isGridLayout: selected });
    };
    updatedCheckedItems = (checked) => {
        this.setState({ checkedItem: checked });
    };

    toggleEditFile = (fileId) => {
        this.setState({
            toggleEditFile: !this.state.toggleEditFile,
            markedItem: fileId ? fileId : null
        });
    }

    toggleAddTeam = () => {
        this.setState({ toggleAddTeam: !this.state.toggleAddTeam });
    }


    toggleDeleteGallery = () => {
        this.setState({ toggleDeleteGallery: !this.state.toggleDeleteGallery });
    }

    removeGallery = (feedIds, callback) => {
        this.props.removeGallery(feedIds, () => {
            this.setState({ checkedItems: {}, markedItem: null }, () => {
                callback && callback();
            });
        });
    }

    toggleSingleDeleteGallery = (galleryId) => {
        this.setState({ markedItem: galleryId, toggleDeleteGallery: true });
    }

    addNewTeam = (team, cb) => {
        const { engagementTeams } = this.state;

        this.setState({ engagementTeams: [...engagementTeams, team] }, () => { cb && cb() });
    }
    updateSelected = (index) => {
        this.setState({ selectedSection: index });
    }

    renderSection = () => {
        const { selectedSection, editedTeam, searchText, selectedColumnSort, sortDesc, normalizedColumns, columns, toggledColumns } = this.state;
        const { event, team } = this.props;

        switch (selectedSection) {
            case 0:
                return (
                    <div className="mt-20">
                        <InputField
                            label={'Name'}
                            value={editedTeam.name}
                            type={'text'}
                            onChange={(e) => {
                                this.setState({ editedTeam: { ...editedTeam, name: e.target.value }, editing: true });
                            }}
                        />
                        <SelectField
                            label={'Group'}
                            classes="w-100"
                            name="registrationGroup"
                            options={event.groups.map(group => {
                                return { label: group.name, value: group._id }
                            })
                            }
                            value={
                                editedTeam.group && event.groups.find(group => group._id === editedTeam.group) ? (
                                    {
                                        label: event.groups.find(group => group._id === editedTeam.group).name,
                                        value: editedTeam.group
                                    }
                                ) : (
                                    {
                                        label: '',
                                        value: ''
                                    }
                                )
                            }
                            onChange={(path) => {
                                this.setState({
                                    editedTeam: { ...editedTeam, group: path.value },
                                    editing: true
                                });
                            }}
                        />
                    </div>
                )

            case 1:

                let searchedEntries = editedTeam.attendees || [];

                if (searchText.length > 0) {
                    const searchTerms = searchText.toLowerCase().split(' ');
                    searchTerms.forEach((term) => {
                        if (term != '') {
                            searchedEntries = searchedEntries.filter((entry) => {
                                let found = false;
                                Object.keys(columns).forEach((key) => {
                                    if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                        found = true;
                                    }
                                });
                                return found;
                            });
                        }
                    });
                }

                if (selectedColumnSort) {
                    searchedEntries = searchedEntries.sort((a, b) => {
                        const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                        if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                            switch (columnType) {
                                case 'string':
                                    return a[selectedColumnSort.key]
                                        .toLowerCase()
                                        .trim()
                                        .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                                case 'number':
                                    return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                                case 'date':
                                    return (
                                        new Date(a[selectedColumnSort.key]).getTime() -
                                        new Date(b[selectedColumnSort.key]).getTime()
                                    );
                                case 'time':
                                    return (
                                        new Date(a[selectedColumnSort.key]).getTime() -
                                        new Date(b[selectedColumnSort.key]).getTime()
                                    );
                                case 'boolean':
                                    const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                                    const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                                    return a1.localeCompare(b1);
                                default:
                                    return a[selectedColumnSort.key]
                                        .toLowerCase()
                                        .trim()
                                        .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                            }
                        } else if (a[selectedColumnSort.key]) {
                            return 1;
                        }
                        return -1;
                    });

                    searchedEntries = sortDesc ? searchedEntries.reverse() : searchedEntries;
                }
                return (
                    <div className="sectionBody posRel mb-0 p-0" >
                        <ActionButtonContainer
                            mainActions={[]}
                            searchEnabled={true}
                            searchEntries={(searchText) => {
                                this.setState({ searching: searchText != '' ? true : false, searchText: searchText ? searchText : '' });
                            }}
                        />
                        <ViewsTable
                            title="Attendees"
                            style={{ margin: 0 }}
                            classes="nested"
                            columns={normalizedColumns}
                            toggledColumns={toggledColumns}
                            data={searchedEntries}
                            disableCheck={true}
                            mainColumnActive={false}
                            checked={{}}
                            checkRow={(entryId) => {

                            }}
                            checkAllRows={(entryIds) => {

                            }}
                            sortData={this.sortData}
                        />
                    </div>
                );

            default:
                break;
        }
    }

    cancelEdit = () => {
        this.setState({ editing: false, editedTeam: this.props.team });
    }

    saveUpdates = async () => {
        const { editedTeam } = this.state;
        const { team } = this.props;


        API().patch(`/organizations/${this.props.orgId}/events/${this.props.eventId}/engagementteams/${team._id}`, { name: editedTeam.name, group: editedTeam.group, icon: editedTeam.icon }).then((res) => {
            this.setState({ editing: false });

            if (res.data) {
                this.props.updateTeams(res.data, () => {
                    this.setState({ editedTeam: this.props.team, editing: false });
                });
            }
        }).catch((err) => {
            console.log(err);
        }
        );
    }


    saveImage = async (data, callback) => {
        const { eventId, orgId } = this.props;
        const { attendee, editedAttendee } = this.state;
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/attendees/${attendee._id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {

                if (res.data) {
                    let savedProfilePicture = res.data.profilePicture;
                    this.setState({ attendee: { ...attendee, profilePicture: savedProfilePicture }, editedAttendee: { ...editedAttendee, profilePicture: savedProfilePicture } }, () => {
                        callback && callback();
                    });
                }
            }).catch(err => {
                console.log('err', err)
            })
    }


    render() {
        const {
            searchTerm,
            engagementTeams,
            editing,
            selectedSection,
            editedTeam,
        } = this.state;
        const sortedTeams = engagementTeams || [];
        const { orgId, eventId, } = this.props;
        ;
        let searchedEntries = sortedTeams;

        if (searchTerm.length > 0) {
            /* searchedEntries = engagementTeams.filter((entry) => {
                return entry.feedName.toLowerCase().includes(searchTerm.toLowerCase());
            }); */
        }


        return (
            <div className={`sectionContainer`}>
                <div className={`sectionHeader `}>
                    <div style={{ width: 30, height: 30 }}>
                        <Link to={`./`} >
                            <button style={{ padding: 7, marginLeft: -7, marginTop: -7, fontSize: 16, }}><i className='las la-times'></i></button>

                        </Link>
                    </div>
                </div>
                <div className="sectionTitleBar">
                    <div className='profileIcon mr-15'
                        style={{ position: 'relative' }}
                        onClick={() => {
                            if (!editedTeam.icon) {
                                this.setState({
                                    uploadingTeamIcon: true,
                                });
                            }

                        }}
                    >
                        {editedTeam.icon ?
                            (<img src={editedTeam.icon} alt={editedTeam.name} />)
                            :
                            (<h1 className='acr white'>{editedTeam.name && editedTeam.name.length > 0 ? editedTeam.name.charAt(0) : ''}</h1>)}

                        <div className="addImageIcon">

                            {editedTeam.icon ? <div className='flex'
                            >
                                <div className='replace mr-5 white'
                                    onClick={() => {
                                        this.setState({
                                            uploadingTeamIcon: true,
                                        });
                                    }}
                                >
                                    <i className="las la-redo-alt"></i>
                                </div>

                                <div className='white'>|</div>


                                <div className='remove ml-5 white'
                                    onClick={() => {

                                        this.setState({
                                            editedTeam: {
                                                ...editedTeam, icon: ''
                                            }, editing: true
                                        });
                                    }}
                                >
                                    <i className="las la-trash"></i>
                                </div>


                            </div> : <i className="las la-camera white" />}

                        </div>


                    </div>
                    <div className="flex column jcc">
                        <h3> {editedTeam.name}</h3>
                        <div></div>
                    </div>


                    <div className="ml-a">
                        {/*  {subActions && (
                            <UncontrolledDropdown className="ml-a" style={{ float: 'right', marginTop: 20 }}>
                                <DropdownToggle className="neu mr-10">
                                    <i className='las la-ellipsis-h'></i>
                                </DropdownToggle>
                                <DropdownMenu right className="columnDropdown p-20">
                                    <h5 className='mb-10'>Options</h5>
                                    {subActions.map((sa, index) => {
                                        return sa.type === 'link' ? (
                                            <Link to={sa.target}>
                                                <DropdownItem>
                                                    {sa.iconClass && <i className={`mr-10 ${sa.iconClass}`} />}
                                                    {sa.label}
                                                </DropdownItem>

                                            </Link>) : (
                                            <DropdownItem onClick={sa.onClick}>
                                                {sa.iconClass && <i className={`mr-10 ${sa.iconClass}`} />}
                                                {sa.label}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        )} */}
                    </div>
                    <SectionHeader
                        subActions={[{ onClick: this.toggleDelete, label: <span><i className='las la-trash mr-10'></i>Delete</span> }]} />
                </div>
                <div className="sectionHeaderChildren">
                    <TabsContainer
                        tabs={[
                            {
                                title: <span>Information</span>,
                            },
                            {
                                title: <span>Attendees</span>,
                            }

                        ]}
                        updateSelected={this.updateSelected}
                        selectedIndex={selectedSection}
                    />
                </div>
                <div className="sectionBody">{this.renderSection()}</div>

                <SectionFooter
                    updatedAt={editedTeam.updatedAt}
                    cancelEdit={this.cancelEdit}
                    saveEdit={this.saveUpdates}
                    editing={editing}
                    lastEditedBy={''}
                />




                {this.state.uploadingTeamIcon && <FilesUploaderModal
                    isOpen={this.state.uploadingTeamIcon}
                    toggle={() => {
                        this.setState({
                            uploadingTeamIcon: false,
                        });
                    }}
                    eventId={this.props.eventId}
                    links={{
                        getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
                        addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
                    }}
                    orgId={this.props.orgId}
                    addFiles={(fileURL) => {
                        this.setState({
                            uploadingTeamIcon: false,
                            editedTeam: { ...editedTeam, icon: fileURL },
                            editing: true
                        });

                    }}
                />}
            </div >



        );
    }
}

export default withRouter(EngagementTeams);
